// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2KcE9","head":"ProcedureTableInfo_head__2gPDV"};